module.exports = __webpack_public_path__ + "img/icon33.3cfed596.png";